import styles from './LandingLayout.module.css';

const AboutPage = () => (
  <section className={styles.section}>
    <div className={styles.sectionInner}>
      <div className={styles.sectionLabel}>About the Platform</div>
      <h2 className={styles.sectionTitle}>Built for Jain Communities</h2>
      <p className={styles.sectionLead}>
        JainamSevaSetu is a purpose-built web platform that helps Jain temple organisations
        (Derasars) run their operations digitally — from accepting donations to maintaining a full
        double-entry accounting ledger.
      </p>
      <div className={styles.aboutGrid}>
        <div className={styles.aboutItem}>
          <h3>Multi-Derasar Support</h3>
          <p>Each Derasar operates as an independent, isolated tenant. Members can belong to multiple Derasars and switch context seamlessly.</p>
        </div>
        <div className={styles.aboutItem}>
          <h3>Complete Accounting</h3>
          <p>Full chart of accounts with double-entry ledger, financial years, opening balances, receipts, and payment vouchers.</p>
        </div>
        <div className={styles.aboutItem}>
          <h3>Donation Categories</h3>
          <p>Organise donations under the four canonical Jain categories: Angi, Dev Dravya, Jiv Daya, and Sarva Sadharan.</p>
        </div>
        <div className={styles.aboutItem}>
          <h3>Donation Offer Tracking</h3>
          <p>Members commit donation offers and the system tracks payments against them, automatically updating offer status from pending to completed.</p>
        </div>
        <div className={styles.aboutItem}>
          <h3>Family Management</h3>
          <p>Create and manage households within a Derasar. A family head approves member join requests and tracks family-level contributions.</p>
        </div>
        <div className={styles.aboutItem}>
          <h3>Role-Based Access</h3>
          <p>Granular access control with three tiers: platform super admin, Derasar admin, and community member — each with tailored permissions.</p>
        </div>
        <div className={styles.aboutItem}>
          <h3>Financial Reports</h3>
          <p>Generate balance sheets, income and expenditure statements, category fund summaries, day books, and gold registers.</p>
        </div>
        <div className={styles.aboutItem}>
          <h3>Online Payments</h3>
          <p>Each Derasar can connect their own Razorpay account to accept donations online directly into their bank account.</p>
        </div>
      </div>
    </div>
  </section>
);

export default AboutPage;
